import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatRadioModule } from '@angular/material/radio'
import { AccountFacade } from '@galabid/gb-dashboard/account/data-access'
import { ClientAccountEntity } from '@galabid/gb-dashboard/client-account/data-access'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardClientAccountUtilsModule } from 'libs/gb-dashboard/client-account/utils/src/lib/gb-dashboard-client-account-utils.module'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'
import { GbDashboardSharedFeatureModule } from 'libs/gb-dashboard/shared/feature/src/lib/gb-dashboard-shared-feature.module'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { Observable, of } from 'rxjs'

@Component({
  selector: 'gb-presenter-template-config',
  imports: [
    GbDashboardSharedFeatureModule,
    MatRadioModule,
    GbDashboardClientAccountUtilsModule,
    ReactiveFormsModule,
    FormsModule,
    GbDashboardSharedUiModule,
    TranslateModule,
    AsyncPipe,
  ],
  templateUrl: './gb-presenter-template-config.component.html',
  styleUrl: './gb-presenter-template-config.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterTemplateConfigComponent {
  @Input() set template(value: ProjectorTemplatesEntity | null | undefined) {
    if (value) {
      this.form.patchValue({ ...value, clientAccounts: value.client_accounts })
      this.checkClientAccounts(value)
    }
  }

  @Input() displayPermissions = true

  get clientAccounts(): Partial<ClientAccountEntity>[] {
    return this.form?.get('clientAccounts')?.value || []
  }

  get visibility(): AbstractControl<any> | null {
    return this.form.get('visibility')
  }

  get selectedClientAccounts(): Array<string> {
    return this.clientAccounts?.map((clientAccount) => {
      return clientAccount.name || ''
    })
  }

  get showDistributorWarning$(): Observable<boolean> {
    if (this.visibility?.value === 'client_account') {
      return of(false)
    } else {
      return this.accountFacade.isDistributor$.pipe()
    }
  }

  form = new FormGroup({
    name: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] }),
    description: new FormControl<string>('', { nonNullable: true }),
    visibility: new FormControl<'public' | 'client_account'>('public', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    clientAccounts: new FormControl<Partial<ClientAccountEntity>[]>([]),
  })

  constructor(private accountFacade: AccountFacade) {}

  checkClientAccounts(template: ProjectorTemplatesEntity): void {
    if (template.client_accounts.length > 0) {
      this.visibility?.setValue('client_account')
    } else {
      this.visibility?.setValue('public')
    }
  }
}
